import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { mercureSubscribe } from "../../services/mercure";
import { getCaseLink } from "../../services/Product/ProductService/productService";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import { MercureNotification } from "../../types/Mercure/MercureNotification";
import { ProductUnion } from "../../types/ProductUnion";
import { apiGet } from "../../services/Api/apiCall";
import { Note } from "../../types/Note";

type CaseNotificationsProps = {
  product: ProductUnion;
  setHasUpdates: Function;
  refreshPage: Function;
};

const CaseNotifications = ({ product, setHasUpdates, refreshPage }: CaseNotificationsProps) => {
  const [notification, setNotification] = useState<MercureNotification | null>(null);
  const currentUser = useCurrentUser();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    return mercureSubscribe(product["@id"], setNotification);
  }, [product]);

  useEffect(() => {
    if (!notification || notification.backofficeUser === currentUser["@id"]) {
      return;
    }

    setHasUpdates(true);
    if (!!notification.backofficeUser && notification.backofficeUser !== "/backoffice_users/13") {
      showCaseUpdate(notification);
    } else {
      showSystemNotice(notification);
    }
  }, [notification]);

  const showCaseUpdate = (caseUpdate: MercureNotification) => {
    setHasUpdates(true);
    enqueueSnackbar("", {
      variant: "caseRefreshNotification",
      refreshPage,
      caseUpdate,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });
  };

  const showSystemNotice = async (notification: MercureNotification) => {
    if (notification.type !== "historyLog" || notification.historyLog?.type !== "note") {
      return;
    }

    const entityId = notification.historyLog.logData?.entityId;
    if (typeof entityId !== "number") {
      return;
    }

    try {
      const note = await apiGet<Note>("notes", entityId);
      if (!note.pinned) {
        enqueueSnackbar("", {
          variant: "systemNoteNotification",
          systemNote: note,
          caseLink: getCaseLink(product),
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      }
    } catch {
      return;
    }
  };
  return null;
};
export default CaseNotifications;
